import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';
import {
  DEFAULT_EMPTY_VALUE,
  SHORT_DATE_FORMAT,
} from '~/common/constants/common.constant';
import { formatISOString } from '~/common/utils/date-time.utils';

import AccountDetailsCard from '~/features/integrations/manage/AccountDetailsCard';
import DataSharedCard from '~/features/integrations/manage/DataSharedCard';
import EnrollmentOverview from '~/features/integrations/manage/EnrollmentOverview';
import { ENROLLMENT_VIEWS, type PartnerDefaults } from './types';

const ACCOUNT_FIELD_KEYS = {
  organization: 'common:organization',
  accountId: 'integrations:account.manage.accountId',
  primaryAdmin: 'integrations:account.manage.primaryAdmin',
  subscription: 'integrations:account.manage.subscription',
  linkedDate: 'integrations:account.manage.linkedDate',
  gmFleetOrganization: 'integrations:account.manage.gmFleetOrganization',
} as const;

const TAB_KEYS = {
  overview: 'common:overview',
  enrolled: 'common:enrolled',
  errors: 'integrations:account.manage.errors',
  pending: 'integrations:account.manage.pending',
} as const;

export const PARTNER_DEFAULTS: PartnerDefaults = {
  shop: { isVisible: () => true },
  manage: {
    accountFields: (enrollment) => [
      {
        label: translateText(ACCOUNT_FIELD_KEYS.organization),
        testid: 'organization',
        value: DEFAULT_EMPTY_VALUE,
      },
      {
        label: translateText(ACCOUNT_FIELD_KEYS.accountId),
        testid: 'account-id',
        value: enrollment?.providerAccountId || DEFAULT_EMPTY_VALUE,
      },
      {
        label: translateText(ACCOUNT_FIELD_KEYS.primaryAdmin),
        testid: 'primary-admin',
        value: <span data-heap-redact-text>{DEFAULT_EMPTY_VALUE}</span>,
      },
      {
        label: translateText(ACCOUNT_FIELD_KEYS.subscription),
        testid: 'subscription',
        value: DEFAULT_EMPTY_VALUE,
      },
      {
        label: translateText(ACCOUNT_FIELD_KEYS.linkedDate),
        testid: 'linked-date',
        value: enrollment?.linkedDate
          ? formatISOString(enrollment.linkedDate, SHORT_DATE_FORMAT)
          : DEFAULT_EMPTY_VALUE,
      },
      {
        label: translateText(ACCOUNT_FIELD_KEYS.gmFleetOrganization),
        testid: 'gm-fleet-organization',
        value: DEFAULT_EMPTY_VALUE,
      },
    ],
    enrollmentTiles: [
      ENROLLMENT_VIEWS.ENROLLED,
      ENROLLMENT_VIEWS.ERRORS,
      ENROLLMENT_VIEWS.PENDING,
    ],
    dataSharedRows: [],
    tabs: [
      {
        id: 'overview',
        labelKey: TAB_KEYS.overview,
        sections: [AccountDetailsCard, EnrollmentOverview, DataSharedCard],
      },
      {
        id: ENROLLMENT_VIEWS.ENROLLED,
        labelKey: TAB_KEYS.enrolled,
        sections: [],
      },
      {
        id: ENROLLMENT_VIEWS.ERRORS,
        labelKey: TAB_KEYS.errors,
        sections: [],
      },
      {
        id: ENROLLMENT_VIEWS.PENDING,
        labelKey: TAB_KEYS.pending,
        sections: [],
      },
    ],
  },
};
